import { render, staticRenderFns } from "./deliveryOrderIcon.vue?vue&type=template&id=ca178e7c&scoped=true"
import script from "./deliveryOrderIcon.vue?vue&type=script&lang=js"
export * from "./deliveryOrderIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca178e7c",
  null
  
)

export default component.exports